// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3543":"5f5c614034d62d8e","4549":"0e12ecdc8902ab61"}[chunkId] + ".js";
};